export default "__VITE_ASSET__DBo_atmY__"